import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LogoutIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Logout",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M26.71 17H15.28a1.14 1.14 0 1 1 0-2.28h11.43a1.14 1.14 0 1 1 0 2.28"
    }), /*#__PURE__*/_jsx("path", {
      d: "M23.29 20.43c-.29 0-.58-.11-.81-.33a1.14 1.14 0 0 1 0-1.62l2.62-2.62-2.62-2.62c-.45-.45-.45-1.17 0-1.62s1.17-.45 1.62 0l3.43 3.43c.45.45.45 1.17 0 1.62L24.1 20.1c-.22.22-.52.33-.81.33"
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 31.86H7.29c-1.89 0-3.43-1.54-3.43-3.43V3.29C3.86 1.4 5.4-.14 7.29-.14H21c1.89 0 3.43 1.54 3.43 3.43v3.43a1.14 1.14 0 1 1-2.28 0V3.29c0-.63-.51-1.14-1.14-1.14H7.29c-.63 0-1.14.51-1.14 1.14v25.14c0 .63.51 1.14 1.14 1.14H21c.63 0 1.14-.51 1.14-1.14V25a1.14 1.14 0 1 1 2.28 0v3.43c0 1.89-1.54 3.43-3.43 3.43Z"
    })]
  }));
};